/* eslint-disable tailwindcss/no-custom-classname */
import { type SVGProps } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}

const MastercardGreyRegular = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    id='svg2'
    xmlns='http://www.w3.org/2000/svg'
    x={0}
    y={0}
    viewBox='0 0 100 48'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <style>{'.st0{fill:#c1c2c4}.st3{fill:#100f0d}'}</style>
    <g id='g10' transform='matrix(1.25 0 0 -1.25 0 60)'>
      <g id='g12' transform='scale(.1)'>
        <path
          id='path14'
          className='st0'
          d='M537.2 310c0-47.5-38.4-86-85.8-86s-85.8 38.5-85.8 86 38.4 86 85.8 86 85.8-38.5 85.8-86'
        />
        <path
          id='path16'
          d='M431.3 310c0-47.5-38.4-86-85.8-86s-85.8 38.5-85.8 86 38.4 86 85.8 86 85.8-38.5 85.8-86'
          style={{
            fill: '#636466',
          }}
        />
        <path
          id='path18'
          d='M398.4 377.7c-20-15.8-32.8-40.2-32.8-67.7s12.8-52 32.8-67.7c20 15.7 32.9 40.2 32.9 67.7s-12.9 51.9-32.9 67.7'
          style={{
            fill: '#909195',
          }}
        />
        <path
          id='path20'
          className='st0'
          d='M531.9 264.4v2.5h1v.5h-2.6v-.5h1.1v-2.5h.5zm5.1 0v3.1h-.8l-.9-2.1-.9 2.1h-.8v-3.1h.6v2.3l.9-2h.6l.9 2v-2.3h.4'
        />
        <path
          id='path22'
          className='st3'
          d='M278.7 181.4h-4.9v22.7h4.8v-2.8s4.2 3.4 6.7 3.4c4.9-.1 7.7-4.2 7.7-4.2s2.3 4.2 7.6 4.2c7.8 0 9-7.1 9-7.1v-16.1H305v14.1s0 4.3-5 4.3c-5.2 0-5.7-4.3-5.7-4.3v-14.1h-4.9v14.2s-.5 4.5-4.9 4.5c-5.7 0-5.9-4.6-5.9-4.6l.1-14.2'
        />
        <path
          id='path24'
          className='st3'
          d='M426.8 204.7c-2.5.1-6.7-3.4-6.7-3.4v2.8h-4.8v-22.6h4.9l-.1 14.2s.1 4.6 5.9 4.6c1.1 0 1.9-.2 2.6-.7l1.6 4.4c-1 .4-2.2.7-3.4.7'
        />
        <path
          id='path26'
          className='st3'
          d='M495.4 204.7c-2.5.1-6.7-3.4-6.7-3.4v2.8H484v-22.6h4.9l-.1 14.2s.1 4.6 5.9 4.6c1.1 0 1.9-.2 2.6-.7l1.6 4.4c-1.2.4-2.3.7-3.5.7'
        />
        <path
          id='path28'
          className='st3'
          d='M326.3 200.2c3.9 0 7.1-3.4 7.1-7.6 0-4.2-3.2-7.6-7.1-7.6-3.9 0-7 3.4-7 7.6-.1 4.2 3.1 7.6 7 7.6zm-.9 4.6c-7.3 0-11.2-6.5-11.2-12 0-5.6 4.4-12.1 11.4-12.1 4 0 7.4 3 7.4 3v-2.3h4.8v22.7H333v-2.9c0 .1-3.1 3.6-7.6 3.6'
        />
        <path
          id='path30'
          className='st3'
          d='M466.1 200.2c3.9 0 7.1-3.4 7.1-7.6 0-4.2-3.1-7.6-7.1-7.6-3.9 0-7 3.4-7 7.6 0 4.2 3.1 7.6 7 7.6zm-.9 4.6c-7.3 0-11.2-6.5-11.2-12 0-5.6 4.4-12.1 11.4-12.1 4.1 0 7.4 3 7.4 3v-2.3h4.8v22.7h-4.8v-2.9c0 .1-3.1 3.6-7.6 3.6'
        />
        <path
          id='path32'
          className='st3'
          d='M512.2 200.2c3.9 0 7.1-3.4 7.1-7.6 0-4.2-3.2-7.6-7.1-7.6-4 0-7.1 3.4-7.1 7.6 0 4.2 3.2 7.6 7.1 7.6zm-1 4.6c-7.3 0-11.2-6.5-11.2-12 0-5.6 4.4-12.1 11.4-12.1 4 0 7.4 3 7.4 3v-2.3h4.8v31.7h-4.8v-11.9c0 .1-3.1 3.6-7.6 3.6'
        />
        <path
          id='path34'
          className='st3'
          d='M352.4 180.7c-4.9 0-9.5 3.1-9.5 3.1l2.1 3.2s4.4-2 7.4-2c2 0 5.4.7 5.5 2.7.1 2.1-5.7 2.8-5.7 2.8s-8.6.1-8.6 7.2c0 4.4 4.3 7.3 9.8 7.3 3.1 0 9.1-2.8 9.1-2.8l-2.4-3.8s-4.6 1.8-7 1.9c-2 .1-4.5-.9-4.5-2.7 0-4.8 14.2.4 14.2-9.4 0-6.3-5.8-7.5-10.4-7.5'
        />
        <path
          id='path36'
          className='st3'
          d='M370.7 210.7v-6.6h-4.3v-4.8h4.3v-11.4s-.4-7.7 7.9-7.7c2.3 0 6.8 1.7 6.8 1.7l-1.9 5s-1.8-1.5-3.8-1.5c-3.8.1-3.8 2.5-3.8 2.5v11.4h7.9v4.8H376v6.6h-5.3'
        />
        <path
          id='path38'
          className='st3'
          d='M398.9 200.1h.6c5.8 0 5.8-5.5 5.8-5.5h-11.8s-.3 5.2 5.4 5.5zm.7 4.5c-7.8 0-11.7-6.4-11.7-12 0-5.8 3.5-12.2 12.2-12.2 3.7 0 8.8 3.2 8.8 3.2l-2.2 3.9s-3.5-2.5-6.6-2.5c-6.2 0-6.6 6.1-6.6 6.1h16.6c0-.1 1.2 13.5-10.5 13.5'
        />
        <path
          id='path40'
          className='st3'
          d='m449 187.5 2.2-4.4s-3.5-2.3-7.5-2.3c-8.2 0-12.8 6.1-12.8 12 0 9.1 7.3 11.8 12.2 11.8 4.4 0 8.3-2.5 8.3-2.5l-2.5-4.4s-1.5 2.4-5.9 2.4-6.8-3.8-6.8-7.4c0-4 2.7-7.5 6.8-7.5 3.3-.1 6 2.3 6 2.3'
        />
        <path
          id='path42'
          className='st3'
          d='M533.8 183c.2 0 .2 0 .3-.1.1-.1.1-.1.1-.2s0-.1-.1-.2-.2-.1-.3-.1h-.5v.6h.5zm0 .4h-1v-2.1h.5v.8h.2l.7-.8h.5l-.7.8c.2 0 .4.1.5.2.2.1.2.2.2.5 0 .2-.1.4-.2.5-.2 0-.4.1-.7.1zm-.1-2.9c-.5 0-1 .1-1.3.5-.3.3-.5.8-.5 1.3s.2.9.5 1.3c.3.3.8.5 1.3.5s.9-.1 1.3-.5c.3-.3.5-.8.5-1.3s-.2-.9-.5-1.3-.8-.5-1.3-.5zm0 4.1c-.7 0-1.2-.2-1.7-.7-.5-.5-.7-1-.7-1.6 0-.7.2-1.2.7-1.7.4-.4 1-.7 1.7-.7s1.2.2 1.6.7c.5.5.7 1 .7 1.7s-.2 1.2-.7 1.6c-.4.4-.9.7-1.6.7'
        />
      </g>
    </g>
  </svg>
)

export { MastercardGreyRegular }
